import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import get from 'lodash/get';
import HydratorError from './error';
export var hydratePolymorphicData = function hydratePolymorphicData(hydrators, data, captureException) {
  if (data) {
    if ('__typename' in data) {
      var hydrator = hydrators[data.__typename];
      if (hydrator) {
        try {
          return hydrateData(data, hydrator);
        } catch (error) {
          captureException && captureException(new HydratorError({
            error: error,
            message: "Hydrator failed for [".concat(data.__typename, "].")
          }));
        }
      } else {
        captureException && captureException(new HydratorError({
          message: "Missing hydrator for [".concat(data.__typename, "].")
        }));
      }
    } else {
      captureException && captureException(new HydratorError({
        message: "Missing [__typename] field from data."
      }));
    }
  }
  return null;
};
function getOrSearch(object, path) {
  if (!object) {
    return object;
  }
  if (path.includes(':')) {
    var _path$split = path.split(':'),
      _path$split2 = _slicedToArray(_path$split, 2),
      searchField = _path$split2[0],
      searchValue = _path$split2[1];
    return findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
    );
  }

  return get(object, path);
}
function resolvePath(object, path) {
  // Split the path on each bracket
  var splitPath = path.split(/\(|\)./);

  // Traverse the split path as a tree, resolving as we go
  var current = object;
  var _iterator = _createForOfIteratorHelper(splitPath),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var split = _step.value;
      current = getOrSearch(current, split);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return current;
}
function findNodeByField(edges, fieldId, searchValue) {
  return edges.find(function (edge) {
    return get(edge, fieldId) === searchValue;
  });
}
export function getValues(object, paths) {
  return paths.map(function (path) {
    return resolvePath(object, path);
  });
}
var hydrateData = function hydrateData(data, hydrator) {
  var hydratorPaths = hydrator.hydratorPaths,
    staticFallbacks = hydrator.staticFallbacks;
  return _objectSpread({
    staticFallbacks: staticFallbacks
  }, Object.entries(hydratorPaths).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      dataValue = _ref2[1];
    var item = getValues(data, dataValue);
    if (item) {
      acc[key] = item;
    } else {
      throw new Error("Bad hydrator path: ".concat(key));
    }
    return acc;
  }, {}));
};